import React from 'react';

const StagedResult = ({
  containerClassName, resultClassName = 'event-home__result', result, info,
}) => (
  <div className={containerClassName}>
    <div className={resultClassName}>{result}</div>
    <div className="event-home__info">{info}</div>
  </div>
);

export default StagedResult;
